/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WordFileImage,
    WordFileImageFromJSON,
    WordFileImageFromJSONTyped,
    WordFileImageToJSON,
} from './WordFileImage';

/**
 * プレスリリースWordファイルインポート成功時のレスポンスデータ
 * @export
 * @interface PostPressReleaseWordFileSuccessResponseData
 */
export interface PostPressReleaseWordFileSuccessResponseData {
    /**
     * 本文データ
     * @type {string}
     * @memberof PostPressReleaseWordFileSuccessResponseData
     */
    body: string;
    /**
     * タイトル
     * @type {string}
     * @memberof PostPressReleaseWordFileSuccessResponseData
     */
    title: string | null;
    /**
     * Wordファイル内の画像情報
     * @type {Array<WordFileImage>}
     * @memberof PostPressReleaseWordFileSuccessResponseData
     */
    images: Array<WordFileImage>;
}

export function PostPressReleaseWordFileSuccessResponseDataFromJSON(json: any): PostPressReleaseWordFileSuccessResponseData {
    return PostPressReleaseWordFileSuccessResponseDataFromJSONTyped(json, false);
}

export function PostPressReleaseWordFileSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseWordFileSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'body': json['body'],
        'title': json['title'],
        'images': ((json['images'] as Array<any>).map(WordFileImageFromJSON)),
    };
}

export function PostPressReleaseWordFileSuccessResponseDataToJSON(value?: PostPressReleaseWordFileSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'body': value.body,
        'title': value.title,
        'images': ((value.images as Array<any>).map(WordFileImageToJSON)),
    };
}

